import useFeatureFlags from 'hooks/useFeatureFlags'
import type React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import ResidentMedScreen from '../../ResidentEmarScreens/ResidentMedScreen/ResidentMedScreen'
import MedicationInformationScreenV2 from './MedicationInformationScreenV2'

const MedicationInformationScreenV2Wrapper: React.FC = () => {
  const flags = useFeatureFlags({ flagNames: ['emar_v2_chart'] })?.data
  const location = useLocation()

  const emarV2ChartEnabled = flags?.emar_v2_chart?.enabled ?? false

  const isEditRoute = location.pathname.endsWith('/edit')
  const isNestedRoute =
    isEditRoute ||
    location.pathname.endsWith('/chart') ||
    location.pathname.endsWith('/details')

  if (emarV2ChartEnabled && isNestedRoute && !isEditRoute) {
    const basePath = location.pathname.replace(/\/(chart|details)$/, '')
    return <Navigate to={basePath} replace />
  }

  if (emarV2ChartEnabled && !isNestedRoute) {
    return <MedicationInformationScreenV2 />
  }

  return <ResidentMedScreen />
}

export default MedicationInformationScreenV2Wrapper
